<div class="flex flex-col gap-4">
  <p class="text-sm text-gray-600">
    Open your authenticator app and enter the 6-digit code.
  </p>
  <form class="flex flex-col gap-4" [formGroup]="codeForm">
    <mat-form-field appearance="outline">
      <mat-label>Authenticator Code</mat-label>
      <input
        matInput
        formControlName="code"
        placeholder="123456"
        type="text"
        inputmode="numeric"
        autocomplete="one-time-code"
      />
      @if (codeForm.controls.code.hasError('required')) {
        <mat-error>Code is required</mat-error>
      }
    </mat-form-field>
    <pt-loader-button
      type="raised"
      color="primary"
      [loading]="isLoading()"
      [disabled]="!codeForm.valid"
      (clicked)="verify()"
    >
      Verify
    </pt-loader-button>
  </form>

  @if (errorMessage) {
    <p class="text-sm text-red-500">{{ errorMessage }}</p>
  }

  <button mat-stroked-button (click)="auth.logout()">Go Back</button>
</div>
